<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Finance Summary
      </div>
      <v-spacer> </v-spacer>
    </div>

    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="Start Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="End Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  hide-no-data
                  item-text="text"
                  item-value="value"
                  label="Status"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="category"
                  :items="category_status"
                  hide-no-data
                  item-text="text"
                  item-value="value"
                  label="Category"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  cols="12"
                  sm="3"
                  outlined
                  class="pb-0"
                  v-model="transaction_no"
                  label="Transaction Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  cols="12"
                  sm="3"
                  class="pb-0"
                  v-model="job_number"
                  outlined
                  label="Job Number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  cols="12"
                  sm="3"
                  outlined
                  class="pb-0"
                  v-model="line_number"
                  label="Line Number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  cols="12"
                  outlined
                  sm="3"
                  class="pb-0"
                  v-model="job_number_cleaned"
                  label="Job Number Cleaned"
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="9"
                class="pr-6"
                :class="[
                  userCategory.user_category === 1
                    ? 'offset-md-3'
                    : 'offset-md-3',
                ]"
              >
                <v-btn
                  color="white v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <!-- <v-btn
                    color="green"
                    style="float: right"
                    dark
                    class="mr-2"
                    @click="listPage"
                  >
                    Uploaded List
                  </v-btn> -->
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-2"></v-divider>
          </v-form>
        </template>
      </template>

      <template v-slot:[`item.created_date`]="{ item }">
        <span v-if="item.created_date">
          {{ item.created_date }}
          <span v-if="item.created_by">({{ item.created_by }})</span></span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.updated_date`]="{ item }">
        <span v-if="item.updated_date">
          {{ item.updated_date
          }}<span v-if="item.modified_by"> ({{ item.modified_by }})</span></span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.updated`]="{ item }">
        <span v-if="item.uae_time_updated">
          {{
            item.uae_time_updated
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{
            item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.delivery_date`]="{ item }">
        <span v-if="item.delivery_date">{{
          item.delivery_date | localMomentNew | moment("DD MMM, YYYY ")
        }}</span>
        <span v-else>--</span>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  data: () => ({
    date: null,
    listLoader: false,
    dateMenu: false,
    dateMenuTo: false,
    to_date: null,
    from_date: null,
    line_number: null,
    job_number: null,
    job_number_cleaned: null,
    transaction_no: null,
    category: "",
    headers: [
      {
        text: "Customer Name",
        value: "customer_name",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },
      {
        text: "Customer Code",
        value: "customer_code",
        class: "body-1 font-weight-bold",
        width: "150px",

        sortable: false,
      },
      {
        text: "Account Code",
        value: "account_code",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },
      {
        text: "Account Desc",
        value: "account_desc",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },
      {
        text: "Transaction Date",
        value: "transaction_date",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Amount",
        value: "amount",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Account Code Cleaned",
        value: "account_code_cleaned",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "210px",
      },
      {
        text: "Analysis Code",
        value: "analysis_code",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },
      {
        text: "Analysis Desc",
        value: "analysis_desc",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },

      {
        text: "Category",
        value: "category",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Cost Center",
        value: "costcenter",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },

      {
        text: "Department",
        value: "department",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Department Detailed",
        value: "department_detailed",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "200px",
      },
      {
        text: "Finance Book",
        value: "finance_book",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Hdr Remarks",
        value: "hdr_remarks",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Job Number",
        value: "job_number",
        class: "body-1 font-weight-bold",
        width: "180px",
        sortable: false,
      },
      {
        text: "Job Number Cleaned",
        value: "job_number_cleaned",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Line Number",
        value: "line_number",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Payee Name",
        value: "payee_name",
        class: "body-1 font-weight-bold",
        width: "180px",
        sortable: false,
      },
      {
        text: "Ref Transaction No",
        value: "ref_transaction_no",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "220px",
      },
      {
        text: "Schlay Description",
        value: "schlay_desc",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "200px",
      },
      {
        text: "Segment",
        value: "segment",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Subanalysis Code",
        value: "subanalysis_code",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Subanalysis Desc",
        value: "subanalysis_desc",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },

      {
        text: "Supplier Name",
        value: "supplier_name",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Supplier Code",
        value: "supplier_code",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Supplier Invoice No",
        value: "supplier_invoice_no",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "220px",
      },
      {
        text: "Transaction No",
        value: "transaction_no",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
      {
        text: "Transaction Type",
        value: "transaction_type",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },

      {
        text: "Usage Desc",
        value: "usage_description",
        class: "body-1 font-weight-bold",
        width: "180px",

        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At (By)",
        value: "created_date",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },

      {
        text: "Updated At (By)",
        value: "updated_date",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "180px",
      },
    ],
    filtersArr: {},
    total: 0,
    options: {},
    categories: [],
    totals: 0,
    statuses: [
      { text: "Pending", value: 0 },
      { text: "Successfully mapped", value: 1 },
      { text: "Mapping not found", value: 2 },
    ],
    category_status: [
      { text: "Revenue", value: 1 },
      { text: "Expenses", value: 2 },
    ],

    status: null,
  }),

  created() {},
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["snackBar", "getFianceList"]),

    clearDateInput(from) {
      if (from == "to_date") {
        this.to_date = null;
      } else {
        this.from_date = null;
      }
    },
    clearAll() {
      this.filtersArr = {};
      this.category = null;
      this.from_date = null;
      this.to_date = null;
      this.status = null;
      this.job_number_cleaned = null;
      this.line_number = null;
      this.job_number = null;
      this.transaction_no = null;

      this.fetchList();
    },

    allFilters() {
      this.clientsLoader = true;

      let obj = {
        status: this.status,
        end_date: this.to_date,
        start_date: this.from_date,
        category: this.category,
        job_number_cleaned: this.job_number_cleaned
          ? this.job_number_cleaned.trim()
          : null,
        line_number: this.line_number ? this.line_number.trim() : null,
        job_number: this.job_number ? this.job_number.trim() : null,
        transaction_no: this.transaction_no ? this.transaction_no.trim() : null,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },

    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getFianceList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.getFianceList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          //   this.statues = res.data.status_mapping;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
  },
};
</script>
<style>
.custom-row .col-sm-2 {
  flex: 1 0 16.6666666667% !important;
  max-width: 21.666667% !important;
}
</style>
